import Modal from 'antd/es/modal'
import Button from 'components/button'
import { DeleteMultipleReportsVariables } from 'models'

type Props = {
  visible: boolean
  onClose: () => void
  onDelete: (params: DeleteMultipleReportsVariables) => void
  selectedReportIds: string[]
}

export const DeleteReportModal = (props: Props) => {
  return (
    <Modal
      visible={props.visible}
      onCancel={() => props.onClose}
      title={<h1>Haluatko varmasti poistaa raportit?</h1>}
      closeIcon={false}
      closable={false}
      footer={
        <Button.ButtonGroup style={{ justifyContent: 'flex-end' }}>
          <Button
            label={'Sulje'}
            onClick={() => {
              props.onClose()
            }}
            color="default"
            style={{ marginRight: '1em' }}
          />
          <Button
            label={'Poista'}
            onClick={() => {
              props.onDelete({
                _ids: props.selectedReportIds
              })
            }}
            color="red"
          />
        </Button.ButtonGroup>
      }
    >
      Olet valinnut poistettavaksi yhteensä {props.selectedReportIds.length} {props.selectedReportIds.length === 1 ? 'raportin' : 'raporttia'}.
    </Modal>
  )
}
